import { defineStore } from 'pinia'

const billingCycles = [
  { label: 'Monthly', value: 0, name: 'Monthly' },
  { label: 'Weekly', value: 7, name: 'Weekly' },
  { label: 'Bi-Weekly', value: 14, name: 'BiWeekly' }
]

if (import.meta.env.DEV) {
  billingCycles.push({ label: 'Daily (test only)', value: 1, name: 'Daily' })
}

// The old root store module, carried over 1:1. `set`/`toggle` keep their
// signatures so existing call sites convert mechanically.
export const useAppStore = defineStore('app', {
  state: () => ({
    sidebarShow: true,
    sidebarMinimize: false,
    darkMode: false,
    statusCodes: ['Active', 'Pending', 'Paused', 'Expired', 'Deleted'],
    sellerOfferVisibilityOptions: ['Public', 'Private'],
    statusCodesForNewEntry: ['Active', 'InReview', 'Paused'],
    // name = server-side BillingCycle enum name; some APIs return it instead of the code
    billingCycles
  }),
  actions: {
    toggleSidebarMobile() {
      this.sidebarShow = !this.sidebarShow
    },

    set([variable, value]) {
      this[variable] = value
    },

    toggle(variable) {
      this[variable] = !this[variable]
    }
  }
})
